const cleanCIF = (cif: string): string => {
  if (!cif) {
    return '';
  }

  return cif.replace(/[-. ]/g, '').toUpperCase();
};

export default cleanCIF;
